import React from "react";
import {
  SkeletonCard,
  SkeletonFooter,
  SkeletonImage,
  SkeletonMetric,
  SkeletonMetrics
} from "./MediaCardSkeleton.styled";

const MediaCardSkeleton = () => (
  <SkeletonCard>
    <SkeletonImage />
    <SkeletonFooter>
      <SkeletonMetrics>
        <SkeletonMetric />
        <SkeletonMetric />
        <SkeletonMetric />
      </SkeletonMetrics>
    </SkeletonFooter>
  </SkeletonCard>
);

export default MediaCardSkeleton;
